module.exports = __webpack_public_path__ + "img/light_8.94a17a70.png";